import { DATE_FORMATS } from '../constants';
import { format } from 'date-fns';

export const dateToUtc = (date: Date) => {
  const offset = date.getTimezoneOffset();

  const newTime = date.getTime() + offset * 60 * 1000;

  return new Date(newTime);
};

export const verifyDateValidity = (
  day: number,
  monthIndex: number,
  year: number
) => {
  const date = new Date(year, monthIndex, day);

  const resultingDay = date.getDate();
  const resultingMonth = date.getMonth();
  const resultingYear = date.getFullYear();

  // if the date has shifted, it means it doesn't exist
  if (
    resultingDay !== day ||
    resultingMonth !== monthIndex ||
    resultingYear !== year
  ) {
    return false;
  } else {
    return true;
  }
};

export const getAgeInternal = (birthDate: Date, today: Date) => {
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const formatDateShort = (date: Date) => {
  return format(date, DATE_FORMATS.SHORTMONTH_D_YYYY);
};

export const daysDiff = (date: Date, now: Date) => {
  return Math.abs(
    Math.ceil((date.getTime() - now.getTime()) / (24 * 3600 * 1000))
  );
};

export const formatDatePp = (date: Date) => {
  return format(date, DATE_FORMATS.Pp);
};

export const formatReceiptDate = (date: Date) => {
  const offset = new Date().getTimezoneOffset() / 60;

  return `${format(date, DATE_FORMATS.RECEIPT)} GMT${offset < 0 ? '+' : '-'}${Math.abs(
    offset
  )}`;
};

export const getAge = (birthDate: Date) => {
  const today = new Date();
  return getAgeInternal(birthDate, today);
};

function startOfDayUTC(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
}

export function startOfMonthUTC(date: Date): Date {
  // Note: we do not use `getUTCFullYear` and `getUTCMonth` here
  // because we want to use the User TZ representation of the date.
  // This will translate in exact month and year UTC equivalent.

  // For example, if the date is 2024-01-01 00:03:00 in Bangkok (User TZ),
  // it becomes 2023-12-31 19:03:00 in UTC.
  // If we used `getUTCFullYear`, we would get 2023 instead of 2024.
  return startOfDayUTC(date.getFullYear(), date.getMonth(), 1);
}

export function startOfYearUTC(date: Date): Date {
  // See above about `getFullYear`
  return startOfDayUTC(date.getFullYear(), 0, 1);
}

function endOfDayUTC(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month, day, 23, 59, 59, 0));
}

export function endOfYearUTC(date: Date): Date {
  // `0` means last day of the previous month

  // When we pass `11` (December), it will do `(year, 12, 0)`
  // which will take the last day of December (because `12` is rolled over to January of the next year)
  return endOfDayUTC(date.getFullYear(), 11 + 1, 0);
}
